import { useContext } from "react";
import { Formik, Form, FieldArray, Field } from "formik";
import Input from "components/Input";
import Dropdown from "components/Dropdown";
import ImageUpload from "components/ImageUpload";
import FormWrapper from "components/FormWrapper";
import ResetAndSubmit from "components/ResetAndSubmit";
import * as Yup from "yup";
import TextArea from "components/TextArea";
import { AppContext } from "state";
import { getImageValidationSchema } from "constants/validationSchemas";
import Card from "components/OnboardingFormCard";
import { generateUniqueId } from "utils";

const validationSchema = Yup.object({
    testimonials: Yup.array().of(Yup.object({
        TESTIMONIALS_IMAGE: getImageValidationSchema("Image is required"),
        TESTIMONIALS_NAME: Yup.string().required("Name is required"),
        TESTIMONIALS_TESTIMONIAL: Yup.string().required("Testimonial is required"),
    }))
})

const NewTestimonials = ({ handleNavigate, resetFormData, disableForm }: { handleNavigate, resetFormData?: any, titleAndDesNotRequired?: boolean, disableForm?: boolean }) => {
    const { globalData } = useContext(AppContext);
    const createEmptyTestimonialData = () => ({
        ID: generateUniqueId(),
        DRAWER: false,
        TESTIMONIALS_IMAGE: "",
        TESTIMONIALS_NAME: "",
        TESTIMONIALS_TESTIMONIAL: "",
        TESTIMONIALS_DESIGNATION: "",
    });

    const loadInitialData = () => {
        const savedData = JSON.parse(sessionStorage.getItem("testimonials")) || [];
        return savedData.length ? savedData : [createEmptyTestimonialData()];
    };

    return <Formik
        initialValues={{ testimonials: loadInitialData() }}
        enableReinitialize
        validationSchema={validationSchema}
        onSubmit={(values) => {
            console.log("testimonials form submission values:", values.testimonials);
            sessionStorage.setItem("testimonials", JSON.stringify(values.testimonials));
            handleNavigate();
        }}
    >
        {({ values, handleSubmit, resetForm, errors, setFieldValue }) => <FormWrapper
            title={"Hear It From The Heart"}
            description={"Nothing speaks louder than the voices of the parent who trusts your institution "}
            // titleLink="Why a good website needed?"
            addMore={!!values.testimonials?.[0]?.TESTIMONIALS_NAME && values.testimonials.length < 5 ? () => setFieldValue("testimonials", [...(values.testimonials || []), { ...createEmptyTestimonialData(), DRAWER: true }]) : ""}
            addMoreLabel={"Add Testimonial"}
            childern={<Form onSubmit={handleSubmit}>
                <div>
                    <div className="rounded-2xl my-1 mx-1">
                        <FieldArray name="testimonials">
                            {({ push, remove, form }) => (
                                <div className="grid grid-cols-4 gap-4 sm:grid-cols-1 md:grid-cols-1">
                                    {values.testimonials.map((testimonial, index) => (
                                        <Card
                                            key={testimonial?.ID}
                                            isError={Boolean(errors?.testimonials?.[index])}
                                            index={index}
                                            handleOpenDrawer={() => form.setFieldValue(`testimonials.${index}.DRAWER`, true)}
                                            handleCloseDrawer={() => form.setFieldValue(`testimonials.${index}.DRAWER`, false)}
                                            onDelete={() => {
                                                if (values.testimonials?.length > 1) {
                                                    remove(index)
                                                } else {
                                                    remove(index)
                                                    push({
                                                        ...createEmptyTestimonialData()
                                                    })
                                                }
                                            }}
                                            element={testimonial}
                                            children={<div className="flex flex-wrap gap-x-2 gap-y-4">
                                                <div className="w-full">
                                                    <Field name={`testimonials.${index}.TESTIMONIALS_IMAGE`}>
                                                        {({ field, form }) => (
                                                            <ImageUpload
                                                                disable={disableForm}
                                                                label="Upload Picture"
                                                                // wantHDOption
                                                                maxSize={5}
                                                                labelClassNames="text-[2vh]"
                                                                containerHeight={{
                                                                    width: "7vh",
                                                                    height: "7vh",
                                                                }}
                                                                imageValue={field.value}
                                                                onChange={(item) => form.setFieldValue(`testimonials.${index}.TESTIMONIALS_IMAGE`, item)}
                                                            />
                                                        )}
                                                    </Field>
                                                </div>
                                                <div className="w-full">
                                                    <Input
                                                        disable={disableForm}
                                                        label="Name"
                                                        name={`testimonials.${index}.TESTIMONIALS_NAME`}
                                                        type="text"
                                                        placeHolder="Enter name of person"
                                                        required
                                                    />
                                                </div>
                                                <div className="w-full">
                                                    <Input
                                                        disable={disableForm}
                                                        label="Who are they"
                                                        name={`testimonials.${index}.TESTIMONIALS_DESIGNATION`}
                                                        type="text"
                                                        placeHolder="Enter Who are they"
                                                        required
                                                    />
                                                </div>
                                                <div className="w-full">
                                                    <TextArea

                                                        disabled={disableForm}
                                                        label="What they say about institution"
                                                        name={`testimonials.${index}.TESTIMONIALS_TESTIMONIAL`}
                                                        autoGenerate={true}
                                                        placeHolder=""
                                                        generate={{
                                                            "category": "testimonials",
                                                            "kwargs": {
                                                                "parent_name": testimonial?.TESTIMONIALS_NAME
                                                            }
                                                        }}
                                                    />
                                                </div>
                                            </div>}
                                        />
                                    ))}
                                </div>
                            )}
                        </FieldArray>
                    </div>
                </div>
                {!!values.testimonials?.[0]?.TESTIMONIALS_NAME && <div className="flex justify-center mt-[4vh]">
                    <p className="text-[2vh] bg-gray-200 p-2 rounded-lg text-[black]"><span className="font-manropeB">Note:</span> You can upload up to 5 testimonial, later testimonials automatically upload from parent side</p>
                </div>}
                {!disableForm && <ResetAndSubmit
                  skipButtonAndFunction={() => {
                    handleNavigate()
                  }}
                    submitToolTip={!Boolean(values?.testimonials?.filter(item => !!item?.TESTIMONIALS_NAME)?.length) ? "Please fill in at least one testimonial section with details and images" : Boolean(errors?.testimonials) ? "Please fill in all required fields" : ""}
                    isError={!Boolean(values?.testimonials?.filter(item => !!item?.TESTIMONIALS_NAME)?.length) || Boolean(errors?.testimonials)}
                    resetForm={() => {
                        resetForm();
                        resetFormData();
                    }}
                />}
            </Form>}
        />}
    </Formik>

}

export default NewTestimonials;